export default __webpack_public_path__ + "static/media/planet-1.1117ca54.png";